import { createElementBlock as l, openBlock as t, createElementVNode as r } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
function n(m, e) {
  return t(), l("svg", o, e[0] || (e[0] = [
    r("path", { d: "M1.5 0h21l-1.91 21.563L11.977 24l-8.564-2.438zm7.031 9.75-.232-2.718 10.059.003.23-2.622L5.412 4.41l.698 8.01h9.126l-.326 3.426-2.91.804-2.955-.81-.188-2.11H6.248l.33 4.171L12 19.351l5.379-1.443.744-8.157z" }, null, -1)
  ]));
}
const c = { render: n };
export {
  c as default,
  n as render
};
